const gardenFeaturesZh = {
  // 绿篱机（ht-001 ~ ht-010）
  product_ht_001_feature_1_title: '强劲切割动力',
  product_ht_001_feature_1_desc: '搭载高效能无刷电机，链条速度高达 8m/s，可轻松应对硬木修剪与木料切割，确保切口平整流畅。',
  product_ht_001_feature_2_title: '轻量化单手掌控',
  product_ht_001_feature_2_desc: '机身仅重 1.32kg，人体工学手柄设计平衡卓越，即使在狭窄空间或高处作业，也能实现精准的单手操控。',
  product_ht_001_feature_3_title: '免工具张紧与润滑',
  product_ht_001_feature_3_desc: '配备便捷的链条调节结构，无需复杂工具即可快速调整链条张力；内置高效润滑系统，显著延长链条寿命。',
  product_ht_001_feature_4_title: '多重安全防护',
  product_ht_001_feature_4_desc: '标配顶置护手板与安全锁定开关，有效防止意外启动及木屑飞溅，为高强度作业提供全方位保护。',
  product_ht_001_feature_5_title: '20V 2.0Ah 无绳自由',
  product_ht_001_feature_5_desc: '20V 2.0Ah 电池提供无绳作业自由，在庭院任何位置修剪不受延长线限制。',

  product_ht_002_feature_1_title: '扩展切割容量',
  product_ht_002_feature_1_desc: '导板长度升级至 160mm，配合 8m/s 的强劲链速，能够处理更粗的枝干与木料，显著提升作业范围与效率。',
  product_ht_002_feature_2_title: '卓越的功率重量比',
  product_ht_002_feature_2_desc: '仅 1.43kg 的轻量化机身蕴含工业级动力，兼顾长时作业的舒适性与切割的高爆发力，减少用户疲劳。',
  product_ht_002_feature_3_title: '精准操控与平衡',
  product_ht_002_feature_3_desc: '优化的重心分布设计，确保在各种切割角度下均能稳健掌控，特别适合果园修剪及复杂的户外园林维护。',
  product_ht_002_feature_4_title: '快速维护系统',
  product_ht_002_feature_4_desc: '延续了免工具张紧设计，支持现场快速调整链条；坚固的 32 节链条结构，在高负荷下依然保持优异的耐用性。',
  product_ht_002_feature_5_title: '60 分钟电池充电',
  product_ht_002_feature_5_desc: '20V 2.0Ah 电池 60 分钟充满，不到一小时恢复完整绿篱修剪能力。',

  product_ht_003_feature_1_title: '工业级切断性能',
  product_ht_003_feature_1_desc: ' 链条速度提升至 10m/s，配合 230mm 专业级导板，可轻松应对中大型木材切割，提供媲美油锯的强悍动力体验。',
  product_ht_003_feature_2_title: '全自动润滑系统',
  product_ht_003_feature_2_desc: '配备 270ml 大容量油箱及自动油泵系统，确保长时作业下链条始终保持最佳润滑状态，显著减少磨损并提升工作连续性。',
  product_ht_003_feature_3_title: '双手稳固掌控设计',
  product_ht_003_feature_3_desc: '采用双手柄人体工学布局，前置护手板兼顾平衡与保护，即便在面对高负载切割任务时，依然能提供极佳的稳定感与精确度。',
  product_ht_003_feature_4_title: '持久续航与耐用性',
  product_ht_003_feature_4_desc: '专为高强度现场作业打造，优化的动力输出系统可最大化电池使用效率，配合坚固的机身结构，无惧任何严苛施工环境。',
  product_ht_003_feature_5_title: '2800 mm 伸缩延伸机身',
  product_ht_003_feature_5_desc: '总触达 2800 mm，从地面即可修剪高大绿篱顶部，无需梯子，更安全更快。',

  product_ht_004_feature_1_title: '强悍无刷动力系统',
  product_ht_004_feature_1_desc: '采用先进无刷技术，提供 8m/s 稳定链速，高效率转换动力，确保在连续切割任务中依然保持强劲扭矩，不卡顿、更持久。',
  product_ht_004_feature_2_title: '190mm 进阶切割容量',
  product_ht_004_feature_2_desc: '内置 60ml 油箱并搭载自动油泵系统，作业时自动为链条注油，大幅减少摩擦生热，延长切割组件的使用寿命并免去手动注油麻烦。',
  product_ht_004_feature_3_title: '智能自动润滑技术',
  product_ht_004_feature_3_desc: '内置 60ml 油箱并搭载自动油泵系统，作业时自动为链条注油，大幅减少摩擦生热，延长切割组件的使用寿命并免去手动注油麻烦。',
  product_ht_004_feature_4_title: '极致平衡的操控感',
  product_ht_004_feature_4_desc: '1.7kg 的优化配重设计，将视觉重心与握持手感完美结合。即使单手操作也能精准控制切割路径，显著降低长时间使用的手臂疲劳。',
  product_ht_004_feature_5_title: '现场快速维护设计',
  product_ht_004_feature_5_desc: '延续免工具张紧结构，在作业现场只需几秒即可完成链条调节。配合透明油窗设计，油量剩余一目了然，让维护变得简单高效。',

  product_ht_005_feature_1_title: '520 mm 旋转头修剪机',
  product_ht_005_feature_1_desc: '旋转头可转动，无需移动身体即可修剪绿篱侧面和顶部，非常适合高大界标绿篱。',
  product_ht_005_feature_2_title: '≤25 mm 可调头切割',
  product_ht_005_feature_2_desc: '在任何头部角度下应对 ≤25 mm 枝条，在所有修剪位置保持切割能力。',
  product_ht_005_feature_3_title: '多位置头锁定',
  product_ht_005_feature_3_desc: '头部在多个角度牢固锁定，修剪竖直侧面、平顶和斜面轮廓时无需调节停顿。',
  product_ht_005_feature_4_title: '2.6 kg 旋转头均衡',
  product_ht_005_feature_4_desc: '2.6 kg 均衡旋转头设计确保头部延伸至不同角度时工具依然舒适。',
  product_ht_005_feature_5_title: '20V 无绳配 2.0Ah 电池',
  product_ht_005_feature_5_desc: '20V 2.0Ah 无绳自由，绕绿篱连续旋转和重新定位，无需管理延长线。',

  product_ht_006_feature_1_title: '520 mm 激光切割精密刀片',
  product_ht_006_feature_1_desc: '激光切割刀齿提供格外整洁的绿篱切割效果，促进植物更快复生和更健康的外观。',
  product_ht_006_feature_2_title: '≤22 mm 精密切割能力',
  product_ht_006_feature_2_desc: '专为 ≤22 mm 正式绿篱精密修剪设计，切割质量直接反映庭院美学效果。',
  product_ht_006_feature_3_title: '1300 次/分优质切割频率',
  product_ht_006_feature_3_desc: '1300 次/分配合激光切割刀齿，呈现本系列最精细的绿篱表面效果。',
  product_ht_006_feature_4_title: '2.8 kg 专业修剪重量',
  product_ht_006_feature_4_desc: '2.8 kg 重量提供正式庭院绿篱完美直线水平修剪所需的稳定性。',
  product_ht_006_feature_5_title: 'CE/GS/EMC 认证安全',
  product_ht_006_feature_5_desc: 'CE、GS 和 EMC 三重认证，在住宅和专业庭院环境中安全合规运行。',

  product_ht_007_feature_1_title: '500 mm 超轻庭院修剪机',
  product_ht_007_feature_1_desc: '最轻的绿篱修剪机 2.4 kg，非常适合小型庭院和优先考虑舒适度的用户。',
  product_ht_007_feature_2_title: '≤25 mm 轻量切割动力',
  product_ht_007_feature_2_desc: '尽管是最轻款，这款修剪机仍能应对 ≤25 mm 枝条，多功能庭院绿篱维护。',
  product_ht_007_feature_3_title: '1350 次/分轻体速度',
  product_ht_007_feature_3_desc: '最轻机身中的 1350 次/分，在紧凑住宅绿篱上快速整洁切割，用户疲劳最少。',
  product_ht_007_feature_4_title: '2.4 kg 最低疲劳设计',
  product_ht_007_feature_4_desc: '2.4 kg 是绿篱修剪机系列最轻，专为重视长时间舒适度的用户设计。',
  product_ht_007_feature_5_title: '79 dB 静音邻居友好',
  product_ht_007_feature_5_desc: '≤79 dB，这是本系列最安静的绿篱修剪机，非常适合对噪音敏感的住宅区。',

  product_ht_008_feature_1_title: '450 mm 紧凑庭院修剪机',
  product_ht_008_feature_1_desc: '450 mm 最小刀片，专为小型装饰绿篱、球形造型树和整形庭院灌木的精准施工。',
  product_ht_008_feature_2_title: '≤20 mm 细致装饰切割',
  product_ht_008_feature_2_desc: '≤20 mm 切割能力适合需要频繁精准整形的装饰绿篱上的软嫩新生长。',
  product_ht_008_feature_3_title: '仅 2.2 kg 紧凑重量',
  product_ht_008_feature_3_desc: '仅 2.2 kg，这是最小最轻的修剪机，非常适合装饰造型树的近距离细节作业。',
  product_ht_008_feature_4_title: '78 dB 轻语般静音',
  product_ht_008_feature_4_desc: '≤78 dB 是绿篱修剪机系列中最低的噪音值，非常适合早晨庭院作业。',
  product_ht_008_feature_5_title: '紧凑 698 mm 总长',
  product_ht_008_feature_5_desc: '698 mm 的短总体长度使这款修剪机成为最灵活的装饰精密施工工具。',

  product_ht_009_feature_1_title: '550 mm 重型绿篱刀片',
  product_ht_009_feature_1_desc: '550 mm 刀片应对大型过度生长绿篱和标准长度修剪机难以切割的粗壮嫩枝。',
  product_ht_009_feature_2_title: '≤30 mm 最大枝条切割能力',
  product_ht_009_feature_2_desc: '30 mm 切割能力是绿篱修剪机系列最高，应对带粗枝条的大型成熟绿篱。',
  product_ht_009_feature_3_title: '4.0Ah 延长续航电池',
  product_ht_009_feature_3_desc: '20V 4.0Ah 提供大型庭院和商业绿篱维护合同所需的延长运行时间。',
  product_ht_009_feature_4_title: '2.8 kg 强力重型机身',
  product_ht_009_feature_4_desc: '2.8 kg 机身提供应对最高要求的粗枝条绿篱修剪所需的质量和稳定性。',
  product_ht_009_feature_5_title: '1200 次/分重型生长速度',
  product_ht_009_feature_5_desc: '1200 次/分针对 ≤30 mm 枝条的最大切割动力调整，而非软嫩生长的速度。',

  product_ht_010_feature_1_title: '520 mm 专业庭院刀片',
  product_ht_010_feature_1_desc: '专业规格 520 mm 刀片，硬化刀齿，在各种绿篱树种的频繁商业使用中表现卓越。',
  product_ht_010_feature_2_title: '≤25 mm 专业切割能力',
  product_ht_010_feature_2_desc: '在女贞、鹅耳枥和紫杉等所有常见商业绿篱树种上应对 ≤25 mm 枝条。',
  product_ht_010_feature_3_title: '24 个月商业质保',
  product_ht_010_feature_3_desc: '2 年质保支持每天在多处物业使用这款修剪机的专业园林承包商。',
  product_ht_010_feature_4_title: '1350 次/分商业速度',
  product_ht_010_feature_4_desc: '1350 次/分持续商业级切割速度，应对大型客户物业的全天绿篱维护。',
  product_ht_010_feature_5_title: '硬化刀片钢，持久耐用',
  product_ht_010_feature_5_desc: '硬化刀片钢在重度商业使用中保持锋利度，明显比标准庭院修剪机刀片更持久。',

  // 高枝锯（pp-001 ~ pp-010）
  product_pp_001_feature_1_title: '极限伸展作业范围',
  product_pp_001_feature_1_desc: '整机长度达 297cm，配合 58cm 的伸缩延长杆，无需梯子即可轻松完成高大绿篱顶部的修剪，显著提升作业安全性与便利性。',
  product_pp_001_feature_2_title: '11档全方位旋转刀头',
  product_pp_001_feature_2_desc: '刀头支持从 -60° 到 +90° 范围内的 11 个位置调节。无论正面垂直切割还是顶部水平修剪，都能找到最理想的切入角度。',
  product_pp_001_feature_3_title: '高频专业切割效率',
  product_pp_001_feature_3_desc: '具备 2300 spm 的高空载转速，配合 410mm 优质导板与 15mm 齿间距，确保修剪过程干净利落，有效避免扯伤植物枝条。',
  product_pp_001_feature_4_title: '轻量化与平衡系统',
  product_pp_001_feature_4_desc: '采用轻量化铝合金长杆设计，优化了重心分布。配合背带使用，可有效减轻长时间高空作业带来的肩部与手臂负担。',
  product_pp_001_feature_5_title: '工业级耐用刀片',
  product_pp_001_feature_5_desc: '49cm 的可见刀片采用高强度合金材质，专为高强度园林维护打造。出色的抗磨损性能，确保在各种气候条件下依然保持锋利持久。',
  
  product_pp_002_feature_1_title: '11档全方位旋转刀头',
  product_pp_002_feature_1_desc: '具备高达 32mm 的最大切断直径，配合工业级硬质合金刀头，可轻松剪断干枯或坚硬的高空粗枝，让清理作业一次到位。',
  product_pp_002_feature_2_title: '5档多角度偏转刀头',
  product_pp_002_feature_2_desc: '刀头支持从 -76° 到 +76° 的 5 个位置锁定，能够巧妙避开错综复杂的枝干，在密集的树冠中也能找到最佳剪切角度。',
  product_pp_002_feature_3_title: '安全的高空伸展性能',
  product_pp_002_feature_3_desc: '整机长度达 258cm，并包含 58cm 伸缩延长系统。让您告别摇晃的梯子，站在地面即可安全完成高难度的高枝清理工作。',
  product_pp_002_feature_4_title: '轻量化与长效耐用',
  product_pp_002_feature_4_desc: '采用高强度铝合金材质，在保证整机刚性的同时实现了极佳的轻量化。配合背带设计，极大缓解了高空作业时的手部与肩部压力。',
  product_pp_002_feature_5_title: '自动链条润滑',
  product_pp_002_feature_5_desc: '自动给油器即使在最大 3200 mm 触达时也保持链条正确润滑，减少链条磨损。',
  
  product_pp_003_feature_1_title: '卓越的高空伐木能力',
  product_pp_003_feature_1_desc: '拥有 200mm 的有效切割长度，配合 5m/s 的稳健链速，专门针对高空粗壮枝干设计，提供远超手动工具的切割效率，轻松完成繁重的伐木任务。',
  product_pp_003_feature_2_title: '双段可调式长杆系统',
  product_pp_003_feature_2_desc: '支持 2120mm 与 2700mm 两种作业长度切换，灵活适配不同高度的作业需求。无需攀爬梯子，即可实现地面对高空林木的精准维护。',
  product_pp_003_feature_3_title: '智能持续润滑系统',
  product_pp_003_feature_3_desc: '内置 80ml 储油箱，作业时自动为链条提供润滑，有效降低高温磨损，确保链条在长达 2.7 米的远端作业时依然保持锋利与流畅。',
  product_pp_003_feature_4_title: '增强型双手柄稳固设计',
  product_pp_003_feature_4_desc: '采用辅助 D 型手柄配合后端控制柄的设计，大幅提升了长杆工具在伸展状态下的支撑稳定性，即便面对坚硬木材，也能实现纹丝不动的精准切割。',
  product_pp_003_feature_5_title: '工业级全天候耐用性',
  product_pp_003_feature_5_desc: '机身结构坚固，采用抗冲击材质打造。3.25kg 的优化配重结合专业背带，旨在为极端施工环境下的专业用户提供长寿命、高强度的作业保障。',


  product_pp_004_feature_1_title: '轻量化与平衡系统',
  product_pp_004_feature_1_desc: '采用轻量化铝合金长杆设计，优化了重心分布。配合背带使用，可有效减轻长时间高空作业带来的肩部与手臂负担。',
  product_pp_004_feature_2_title: '≤80 mm 轻量高触达',
  product_pp_004_feature_2_desc: '轻量设计配合 ≤80 mm 切割能力，长触达修剪不牺牲切割动力。',
  product_pp_004_feature_3_title: '3.5 m/s 轻量速度',
  product_pp_004_feature_3_desc: '最轻机身中提供 3.5 m/s，快速切割与轻松操控结合，减少用户疲劳。',
  product_pp_004_feature_4_title: '20V 电池轻量组合',
  product_pp_004_feature_4_desc: '20V 2.0Ah 电池保持最轻修剪机的轻量，树木间移动无需拖拉电源线。',
  product_pp_004_feature_5_title: '低反弹链条设计',
  product_pp_004_feature_5_desc: '低反弹链条降低切割时导板突然运动的风险，对安全头顶修剪很重要。',


  product_pp_005_feature_1_title: '工业级耐用刀片',
  product_pp_005_feature_1_desc: '49cm 的可见刀片采用高强度合金材质，专为高强度园林维护打造。出色的抗磨损性能，确保在各种气候条件下依然保持锋利持久。',
  product_pp_005_feature_2_title: '≤100 mm 最大枝条切割',
  product_pp_005_feature_2_desc: '100 mm 切割能力应对无需专业树艺师设备的最大住宅树木修剪任务。',
  product_pp_005_feature_3_title: '4.0 m/s 最高链条速度',
  product_pp_005_feature_3_desc: '4.0 m/s 是可用的最高链条速度，能够快速清除浓密树冠大型树木的枝条。',
  product_pp_005_feature_4_title: '20V 4.0Ah 重型修剪续航',
  product_pp_005_feature_4_desc: '4.0Ah 电池支持 250 mm 导板和 100 mm 切割能力的较高功耗，续航更长。',
  product_pp_005_feature_5_title: '4.0Ah 延长续航',
  product_pp_005_feature_5_desc: '4.0Ah 电池提供专门针对 250 mm 重型导板较高能耗需求选择的延长续航。',

  

  // 园林养护（lc-001 ~ lc-010）
  product_lc_001_feature_1_title: '高速精密研磨性能',
  product_lc_001_feature_1_desc: '拥有 5000/min 的高空载转速，配合专业级磨轮，可快速修复受损刀刃，让钝化的链条瞬间恢复如新的切割锋利度。',
  product_lc_001_feature_2_title: '全方位多角度调节系统',
  product_lc_001_feature_2_desc: '支撑左/右 -35° 到 +35° 的宽幅角度调节，适配各种品牌及不同规格的链条。精准的角度刻度盘确保每一节链子都能获得一致的研磨效果。',
  product_lc_001_feature_3_title: '自带 LED 照明作业系统',
  product_lc_001_feature_3_desc: '内置高亮度 LED 工作灯，即便在光线不足的车间或库房，也能清晰观察研磨接触面，确保操作的极端精准与安全。',
  product_lc_001_feature_4_title: '智能重启保护与安全设计',
  product_lc_001_feature_4_desc: '配备 Restart 保护功能，有效防止断电后再通电时的意外启动。结合防震底座设计，在高速运转下依然保持稳如泰山的操控感。',
  product_lc_001_feature_5_title: '紧凑便携的工业结构',
  product_lc_001_feature_5_desc: ' 1.9kg 的紧凑机身结合人体工学操作手柄，既方便固定于工作台，也易于随身携带至施工现场，是链锯长效服役的必备维护神器。',

  product_lc_002_feature_1_title: '巅峰研磨效能',
  product_lc_002_feature_1_desc: '拥有高达 6500/min 的超高转速，研磨效率显著提升。即使是磨损严重的硬质链条，也能在短时间内恢复专业级的锐利度。',
  product_lc_002_feature_2_title: '极简轻量化设计',
  product_lc_002_feature_2_desc: '机身优化至仅 1.65kg，是该系列中最轻便的专业型号。配合人体工学握把，极大提升了从车间到现场的便携性与操作灵活性。',
  product_lc_002_feature_3_title: '全天候 LED 精准视野',
  product_lc_002_feature_3_desc: '自带强力 LED 工作灯，消除阴影干扰。确保在暗处或复杂作业环境下，用户依然能精准对齐每一个链节，实现“零误差”研磨。',
  product_lc_002_feature_4_title: '多品牌兼容调节',
  product_lc_002_feature_4_desc: '提供左右各 35° 的精密角度调节范围，完美适配市面上主流的各类链条规格。一个工具即可解决整个工具库的链条维护需求。',
  product_lc_002_feature_5_title: '专业级安全防护系统',
  product_lc_002_feature_5_desc: '搭载智能重启防护功能，有效规避断电后的误启动风险。配合坚固的保护罩与防滑底座，为高强度作业提供全方位的工业级安全保障。',

  product_lc_003_feature_1_title: '350 mm 长刀片草坪剪',
  product_lc_003_feature_1_desc: '350 mm 刀片沿割草机无法触达的墙壁、围栏和铺装边缘修剪草坪。',
  product_lc_003_feature_2_title: '≤20 mm 精密剪草能力',
  product_lc_003_feature_2_desc: '针对 ≤20 mm 草坪生长优化，沿墙壁和铺装边缘精准整洁修剪草坪边缘。',
  product_lc_003_feature_3_title: '1350 次/分剪草行程速度',
  product_lc_003_feature_3_desc: '1350 次/分往复刀片，沿墙壁和铺装边缘如剪刀般整洁切割草坪。',
  product_lc_003_feature_4_title: '2.6 kg 受控剪草重量',
  product_lc_003_feature_4_desc: '2.6 kg 重量提供足够的稳定性，沿墙根和边界进行直线剪草。',
  product_lc_003_feature_5_title: '78 dB 静音庭院修剪',
  product_lc_003_feature_5_desc: '静音 ≤78 dB 的草坪边缘修剪，在最安静的住宅小区也可接受。',

  product_lc_004_feature_1_title: '高速 240 km/h 吹叶机',
  product_lc_004_feature_1_desc: '最大 240 km/h 的风速快速清除小径、车道和露台上的树叶、草屑和碎屑。',
  product_lc_004_feature_2_title: '20V 无绳吹送自由',
  product_lc_004_feature_2_desc: '20V 无绳操作在庭院各处自由移动，无需管理气管或电源线。',
  product_lc_004_feature_3_title: '1.2 kg 超轻吹叶机',
  product_lc_004_feature_3_desc: '仅 1.2 kg，这款吹叶机可单手使用，快速清理小径和清除碎屑。',
  product_lc_004_feature_4_title: '72 dB 静音吹送操作',
  product_lc_004_feature_4_desc: '≤72 dB 使这款吹叶机成为系列中最安静的庭院吹叶机，适合早晨清理小径。',
  product_lc_004_feature_5_title: '变速扳机控制',
  product_lc_004_feature_5_desc: '变速扳机允许从轻柔散开碎屑到最大动力清除湿叶的风速控制。',

  product_lc_005_feature_1_title: '300 mm 梳草机滚筒',
  product_lc_005_feature_1_desc: '300 mm 梳草机滚筒清除草坪中的苔藓、枯草层和枯草，改善营养和水分吸收。',
  product_lc_005_feature_2_title: '≤50 mm 梳草深度',
  product_lc_005_feature_2_desc: '50 mm 工作深度穿透枯草层，从草坪中提取压实的有机物。',
  product_lc_005_feature_3_title: '1800 RPM 枯草层清除速度',
  product_lc_005_feature_3_desc: '1800 RPM 滚筒速度高效清除各种草类型的压实枯草层，不损伤根系。',
  product_lc_005_feature_4_title: '2.8 kg 梳草机平衡',
  product_lc_005_feature_4_desc: '2.8 kg 均衡重量在整个割幅范围内提供一致的滚筒与草坪接触，均匀清除枯草层。',
  product_lc_005_feature_5_title: '20V 2.0Ah 无绳梳草',
  product_lc_005_feature_5_desc: '20V 无绳操作允许完整草坪梳草，无需在庭院各处管理电源线。',

  product_lc_006_feature_1_title: '200 mm 打孔机穗钉滚筒',
  product_lc_006_feature_1_desc: '200 mm 打孔机滚筒在压实的草坪土壤中创建通气孔，改善根系生长和排水。',
  product_lc_006_feature_2_title: '≤80 mm 土壤穿透深度',
  product_lc_006_feature_2_desc: '80 mm 穗钉深度深入压实土层，有效通气，改善草坪健康。',
  product_lc_006_feature_3_title: '3500 RPM 通气速度',
  product_lc_006_feature_3_desc: '3500 RPM 打孔机穗钉速度快速穿透压实地面，高效覆盖草坪通气范围。',
  product_lc_006_feature_4_title: '20V 无绳土壤通气',
  product_lc_006_feature_4_desc: '20V 无绳打孔机提供完整草坪覆盖，无电源线限制，完成完整春季处理。',
  product_lc_006_feature_5_title: '3.2 kg 稳定打孔机身',
  product_lc_006_feature_5_desc: '3.2 kg 机身重量确保通气穗钉在坚硬压实地面保持向下压力。',

  product_lc_007_feature_1_title: '280 mm 绿篱和边界修剪机',
  product_lc_007_feature_1_desc: '280 mm 往复刀片在单一多功能工具中应对草坪边缘和低矮边界绿篱修剪。',
  product_lc_007_feature_2_title: '≤60 mm 深部边界切割',
  product_lc_007_feature_2_desc: '60 mm 切割深度应对庭院边界沿线的大量边界草和过度生长的边缘。',
  product_lc_007_feature_3_title: '1800 RPM 多功能修剪',
  product_lc_007_feature_3_desc: '1800 RPM 提供适合精细草坪边缘和较重边界生长的灵活切割速度。',
  product_lc_007_feature_4_title: '3.5 kg 专业边界工具',
  product_lc_007_feature_4_desc: '3.5 kg 专业重量在切割过度生长的边界草和荆棘边缘时提供稳定性。',
  product_lc_007_feature_5_title: '4.0Ah 电池支持长时间作业',
  product_lc_007_feature_5_desc: '4.0Ah 电池为大型物业边界和草坪边缘维护提供延长运行时间。',

  product_lc_008_feature_1_title: '300 mm 专业割草刀片',
  product_lc_008_feature_1_desc: '专业 300 mm 刀片应对商业草坪养护应用的较大草坪和较厚草坪生长。',
  product_lc_008_feature_2_title: '≤50 mm 高草切割',
  product_lc_008_feature_2_desc: '50 mm 切割高度能力应对过度生长草坪和中型粗草，无需预先切割。',
  product_lc_008_feature_3_title: '1500 RPM 重型草坪速度',
  product_lc_008_feature_3_desc: '1500 RPM 提供足够扭矩，以一致的效果切割致密、厚实的草坪生长。',
  product_lc_008_feature_4_title: '3.8 kg 专业级机身',
  product_lc_008_feature_4_desc: '3.8 kg 专业机身，专为在需要定期密集维护的草坪上反复商业使用而设计。',
  product_lc_008_feature_5_title: '4.0Ah 商业续航电池',
  product_lc_008_feature_5_desc: '4.0Ah 提供专业草坪维护承包商在多处物业工作日所需的延长运行时间。',

  product_lc_009_feature_1_title: '12L 庭院喷雾罐',
  product_lc_009_feature_1_desc: '12 升罐容量在大型庭院区域处理草坪施肥、除草剂处理和病虫害防治。',
  product_lc_009_feature_2_title: '1200 RPM 电池泵速度',
  product_lc_009_feature_2_desc: '电池供电 1200 RPM 泵提供一致的喷雾压力，无需手动泵压疲劳。',
  product_lc_009_feature_3_title: '4.2 kg 喷雾均衡',
  product_lc_009_feature_3_desc: '4.2 kg 满载重量在喷雾处理期间携带大型庭院区域周围可以管理。',
  product_lc_009_feature_4_title: '68 dB 超静音喷雾',
  product_lc_009_feature_4_desc: '≤68 dB 是庭院系列中最安静的工具，静音到早晨或傍晚喷雾施用。',
  product_lc_009_feature_5_title: '20V 4.0Ah 延长喷雾续航',
  product_lc_009_feature_5_desc: '4.0Ah 电池提供处理大型草坪和广阔庭院区域的延长喷雾作业时间。',

  product_lc_010_feature_1_title: '300 mm 覆地草刀片',
  product_lc_010_feature_1_desc: '300 mm 覆地草刀片将草屑细切并归还草坪作为天然肥料。',
  product_lc_010_feature_2_title: '≤30 mm 精准覆地草高度',
  product_lc_010_feature_2_desc: '在 ≤30 mm 高度割草并覆地还草，将草屑循环为快速分解并滋养草坪的细粒。',
  product_lc_010_feature_3_title: '2800 RPM 覆地草速度',
  product_lc_010_feature_3_desc: '2800 RPM 产生消失在草坪表面的细小草屑颗粒，无需收集草屑。',
  product_lc_010_feature_4_title: '3.0 kg 覆地草割草机重量',
  product_lc_010_feature_4_desc: '3.0 kg 使这款覆地草割草机在处理额外覆地草机构时操控舒适。',
  product_lc_010_feature_5_title: '20V 2.0Ah 环保割草',
  product_lc_010_feature_5_desc: '零排放 20V 电池割草将营养还给草坪，是袋装和处置草屑的环保替代方案。',

  // ===== 园林工具配件翻译 (ht / pp / lc 系列) =====

  // 绿篱剪系列配件（ht-001 ~ ht-010，所有产品共用相同的 key）
  // ht_accessory_1_name: '20V 锂电池',
  // ht_accessory_1_desc: '大容量 20V 锂电池，长续航，满足大面积绿篱修剪需求',
  // ht_accessory_2_name: '快充充电器',
  // ht_accessory_2_desc: '60 分钟快速充电，高效补充电量，减少等待时间',
  // ht_accessory_3_name: '专用替换配件',
  // ht_accessory_3_desc: '原厂专用替换配件，保证工具始终保持最佳工作状态',
  // ht_accessory_4_name: '配套功能件',
  // ht_accessory_4_desc: '配套功能性配件，扩展工具使用场景与性能',
  // ht_accessory_5_name: '防割安全手套',
  // ht_accessory_5_desc: '专业防割手套，保护双手免受刀片意外伤害，安全作业',
  // ht_accessory_6_name: '安全防护件',
  // ht_accessory_6_desc: '防护安全配件，确保工具在存放和使用中的安全性',
  // ht_accessory_7_name: '维护保养套装',
  // ht_accessory_7_desc: '专业维护工具套装，含清洁刷、润滑剂和擦拭布，延长工具寿命',
  // ht_accessory_8_name: '便携收纳包',
  // ht_accessory_8_desc: '加厚防护收纳包，方便携带和存放，保护工具安全',

  // 高枝锯系列配件（pp-001 ~ pp-010）
  pp_accessory_1_name: '20V 锂电池',
  pp_accessory_1_desc: '防水防尘 20V 大容量锂电池，为长时间高枝修剪提供稳定续航',
  pp_accessory_2_name: '快充充电器',
  pp_accessory_2_desc: '智能快速充电器，LED 指示充电状态，60 分钟完成充电',
  pp_accessory_3_name: '导板链条套装',
  pp_accessory_3_desc: '高品质替换导板和链条套装，保持最佳切割性能',
  pp_accessory_4_name: '链条锉刀套件',
  pp_accessory_4_desc: '专业链条锉刀套件，维护链条锋利度，延长链条使用寿命',
  pp_accessory_5_name: '导板润滑油',
  pp_accessory_5_desc: '天然可降解导板润滑油，减少链条磨损，保护导板',
  pp_accessory_6_name: '肩部背带',
  pp_accessory_6_desc: '可调节减震肩部背带，长时间高枝作业大幅减轻手臂负担',
  pp_accessory_7_name: '防锯护割手套',
  pp_accessory_7_desc: '专业防切割安全手套，保护操作者安全，降低链锯操作风险',
  pp_accessory_8_name: '长款收纳包',
  pp_accessory_8_desc: '专为高枝锯设计的长款收纳包，方便运输和存放，配带多口袋设计',

  // 草坪养护系列配件（lc-001 ~ lc-010）
  lc_accessory_1_name: '20V 锂电池',
  lc_accessory_1_desc: '防水防尘 20V 锂电池，为各类草坪养护工具提供持久稳定电力',
  lc_accessory_2_name: '快充充电器',
  lc_accessory_2_desc: '双 LED 指示快充充电器，60 分钟恢复满电，高效不等待',
  lc_accessory_3_name: '替换切割配件',
  lc_accessory_3_desc: '原厂替换切割部件，保证工具保持最佳切割效果',
  lc_accessory_4_name: '配套功能配件',
  lc_accessory_4_desc: '专用配套功能性配件，增强工具使用灵活性与效率',
  lc_accessory_5_name: '专用耗材',
  lc_accessory_5_desc: '高品质专用耗材，与工具完美兼容，确保持续高效作业',
  lc_accessory_6_name: '防护安全装备',
  lc_accessory_6_desc: '专业防护安全配件，全面保护操作者在作业中的人身安全',
  lc_accessory_7_name: '维护工具套装',
  lc_accessory_7_desc: '完整维护工具套装，涵盖清洁、保养和修理所需全部工具',
  lc_accessory_8_name: '安全防护套装',
  lc_accessory_8_desc: '综合安全防护套装，包括护目镜和手套，确保安全作业',
};

export default gardenFeaturesZh;
